<div class="container-fluid position-relative p-0">
  <router-outlet></router-outlet>
</div>
